import { useRef, useState, useMemo, useEffect } from "react";
import { SnackbarProvider } from "notistack";
import { SnackbarsCustomStyle, AUTO_HIDE_DURATION, MAX_SNACK } from "@Layouts/components/Snackbars";
import { useSelector } from "react-redux";

// Hooks
import { useSubscriptions } from "@/Common/context/subscriptions/Subscriptions";
import { useChangeRequestSubscriptions } from "@/Washouts/hooks/ChangeRequests/useChangeRequestSubscriptions";

// Components
import BodyLayer from "@/Layouts/components/Layers/BodyLayer";
import { SupportCenterContainer } from "./SupportCenterContainer";
import PayPeriodSideBar from "@/Layouts/components/SideBars/PayPeriodSideBar";

// Icons
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import DoneIcon from "@mui/icons-material/Done";

// Types
import { RootState } from "@/redux/store";
import { IPeriodTreeSelection } from "@/Layouts/components/SideBars/PayPeriodSideBar/interfaces";
import { IPayrollClosingSideBarSelected } from "@/Washouts/types/PayrollClosing/PayrollClosingSideBar";

export default function SupportCenterLayer() {
	const locationId = useSelector((state: RootState) => state.location.location?.locationId);
	const lastSelected = useRef<IPayrollClosingSideBarSelected | null>(null);
	const [selection, setSelection] = useState<IPayrollClosingSideBarSelected | null>(null);

	const { clearSubscriptionContext } = useSubscriptions();

	const SideBar = useMemo(() => {
		const sideSelection = function (value: IPeriodTreeSelection) {
			const selected = value as IPayrollClosingSideBarSelected;
			if (selected?._id !== lastSelected.current?._id) {
				lastSelected.current = selected;
				setSelection(selected);
			}
		};

		return <PayPeriodSideBar callbackSelected={sideSelection} isMultiple selectDefaultLastCommissionCycle />;
	}, []);

	useChangeRequestSubscriptions({});

	useEffect(() => {
		return () => {
			clearSubscriptionContext();
		};
	}, [locationId]);

	return (
		<SnackbarProvider
			maxSnack={MAX_SNACK}
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			autoHideDuration={AUTO_HIDE_DURATION}
			iconVariant={{ 
				error: <ErrorOutlineRoundedIcon fontSize="small" className="mr-2" />,
				success: <DoneIcon fontSize="small" className="mr-2" /> 
			}}
			Components={{
				error: SnackbarsCustomStyle,
				success: SnackbarsCustomStyle
			}}
		>
			<BodyLayer fixedContent={SideBar}>
				<SupportCenterContainer key={1} selectedItem={selection} selection={Boolean(selection)} />
			</BodyLayer>
		</SnackbarProvider>
	);
}
